import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Breadcrumbs, Link } from '@mui/material';
import React from 'react';
export const FileManagerBreadcrumbs = (props) => {
    return (React.createElement(Breadcrumbs, { sx: { color: 'white' } },
        props.firstBreadcrumb && props.fullIds.length > 0 && (React.createElement(Link, { onClick: (event) => {
                event.preventDefault();
                props.onGoToDirectory();
            }, href: '.', sx: { display: 'flex', alignItems: 'center', gap: 1, color: themeColors.text.inverse }, underline: 'none', variant: 'body1' },
            React.createElement(ArrowBackIcon, { fontSize: 'small' }),
            props.firstBreadcrumb)),
        props.fullIds.map((id, index, array) => index < array.length - 1 && (React.createElement(Link, { onClick: (event) => {
                event.preventDefault();
                props.onGoToDirectory(id);
            }, href: id, key: id, sx: { display: 'flex', alignItems: 'center', color: themeColors.text.inverse }, underline: 'none', variant: 'body1' }, props.fullNames[index])))));
};
